import type { CSSProperties, ReactNode } from "react";
import { cn } from "../lib/cn";

type ResponsiveCardGridProps = {
  children: ReactNode;
  className?: string;
  minWidth?: string | number;
  gap?: string;
  ariaLabel?: string;
};

export function ResponsiveCardGrid({
  children,
  className,
  minWidth = "220px",
  gap = "0.75rem",
  ariaLabel,
}: ResponsiveCardGridProps) {
  const normalizedMinWidth = typeof minWidth === "number" ? `${minWidth}px` : minWidth;
  const style = {
    display: "grid",
    gap,
    gridTemplateColumns: `repeat(auto-fit, minmax(${normalizedMinWidth}, 1fr))`,
  } satisfies CSSProperties;

  return (
    <div
      className={cn("cf-responsive-card-grid", className)}
      style={{ marginBottom: "var(--cf-space-12)", ...style }}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
}
